import axios from "axios";

import { Constant } from "../../constants";
import { ApiConfig } from "../../configuration";

export const generateFullDate = () => {
    const year = new Date().getFullYear()
    const month = new Date().getMonth() + 1
    const formattedMonth = month.toString().length === 1 ? '0' + month : month
    const day = new Date().getDate()
    const formattedDay = day.toString().length === 1 ? '0' + day : day
    const hour = new Date().getHours()
    const formattedHour = hour.toString().length === 1 ? '0' + hour : hour
    const minute = new Date().getMinutes()
    const formattedMinute = minute.toString().length === 1 ? '0' + minute : minute
    const second = new Date().getSeconds()
    const formattedSecond = second.toString().length === 1 ? '0' + second : second

    return `${year}-${formattedMonth}-${formattedDay} ${formattedHour}:${formattedMinute}:${formattedSecond}`
}

export const generateDate = () => {
    const year = new Date().getFullYear()
    const month = new Date().getMonth() + 1
    const formattedMonth = month.toString().length === 1 ? '0' + month : month
    const day = new Date().getDate()
    const formattedDay = day.toString().length === 1 ? '0' + day : day

    return `${year}-${formattedMonth}-${formattedDay}`
}

const fetchServerDateTime = async () => {
    try {
        const res = await axios.get(`${ApiConfig.baseUrlApi}ws_getservertime.php`)
        if (res.status !== 200) {
            return null
        }

        if (!res.data.server_curtime) {
            return null
        }

        return res.data.server_curtime
    } catch (e) {
        return null
    }
}

export const getServerDate = async () => {
    try {
        const dateTime = await fetchServerDateTime()
        if(!dateTime){
            return
        }
        const serverDateTime = dateTime.split(" ")
        if (serverDateTime.length <= 0) {
            return
        }

        const serverDate = serverDateTime[0]
        localStorage.setItem(Constant.localStorageKey.serverDate, serverDate)
    } catch (e) {

    }
}

export const getServerDateTime = async () => {
    try {
        const dateTime = await fetchServerDateTime()
        if(!dateTime){
            return
        }
        return dateTime
    } catch (e) {

    }
}